export type AdvancedOptions = ['AND', 'NOT'];

export const options: AdvancedOptions = ['AND', 'NOT'];

export const AdvancedOptionsLabel = {
  AND: 'Que contenha',
  NOT: 'Que não contenha'
};
